import { useEffect } from 'react'

type AlertDialogProps = {
  open: boolean
  title: string
  description: string
  closeLabel: string
  onClose: () => void
}

// Zelfde chrome als ConfirmationDialog, maar met één actie — voor meldingen die alleen
// bevestigd hoeven te worden (bv. validatiefouten), zodat ze altijd zichtbaar zijn in plaats
// van als inline tekst die buiten het scherm kan vallen.
export function AlertDialog({ open, title, description, closeLabel, onClose }: AlertDialogProps) {
  useEffect(() => {
    if (!open) return

    function handleEscape(event: KeyboardEvent) {
      if (event.key === 'Escape') onClose()
    }

    window.addEventListener('keydown', handleEscape)
    return () => window.removeEventListener('keydown', handleEscape)
  }, [onClose, open])

  if (!open) return null

  return (
    <div className="confirmation-backdrop" onClick={onClose}>
      <section
        className="confirmation-dialog"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="confirmation-dialog-icon" aria-hidden="true">!</div>
        <div className="min-w-0 pr-8">
          <h2 id="alert-dialog-title">{title}</h2>
          <p id="alert-dialog-description">{description}</p>
        </div>
        <div className="confirmation-dialog-actions">
          <button
            className="confirmation-dialog-button inline-flex min-h-[42px] items-center justify-center rounded-xl bg-accent-600 px-4 py-3 text-sm font-bold text-white transition hover:bg-accent-500"
            type="button"
            onClick={onClose}
          >
            {closeLabel}
          </button>
        </div>
      </section>
    </div>
  )
}
